// Vendor imports
const classNames = require('classnames')
const PropTypes = require('prop-types')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const { CircleButton } = require('client-v2/common/components/buttons')

const bem = BemEntity('OpenInAppButton')

function OpenInAppButton(props) {
  // Internal state
  const [ isVisible ] = React.useState(props.isVisible)
  const [ isDismissed, setDismissed ] = React.useState(false)
  // Event handlers
  const onClick = React.useCallback(
    event => {
      event.stopPropagation()
      setDismissed(true)
      props.onClick()
    },
    [ props.onClick ]
  )
  const onDismiss = React.useCallback(
    event => {
      event.stopPropagation()
      setDismissed(true)
      props.onDismiss()
    },
    [ props.onDismiss ]
  )
  // Rendering
  if (!isVisible) {
    return null
  }
  return (
    tag('div', {
      className: classNames(
        props.className,
        bem.block({ dismissed: isDismissed })
      ),
      onClick
    },
      'Open in App',
      tag(CircleButton, {
        className: bem.element('close'),
        onClick: onDismiss
      })
    )
  )
}

OpenInAppButton.propTypes = {
  // Flags
  isVisible: PropTypes.bool,
  // Values
  className: PropTypes.string,
  // Callbacks
  onClick: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired
}

module.exports = OpenInAppButton
